import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TriangleUpComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__triangleUp"
      width={size}
      height={size}
      viewBox="0 0 6 5"
      fill="none"
    >
      <path d="M3 0L5.59808 4.5L0.401924 4.5L3 0Z" fill={colorVar} />
    </svg>
  );
};

export const TriangleUp = withIcon(TriangleUpComponent);
